// Hiệu ứng phản hồi khi kiểm tra đáp án câu hỏi tương tác trong bài học.
import confetti from 'canvas-confetti'

/** Bắn pháo giấy chúc mừng tại vị trí phần tử (mặc định giữa màn hình). */
export function celebrateCorrect(el?: HTMLElement | null) {
  let origin = { x: 0.5, y: 0.6 }
  if (el) {
    const r = el.getBoundingClientRect()
    origin = {
      x: Math.min(1, Math.max(0, (r.left + r.width / 2) / window.innerWidth)),
      y: Math.min(1, Math.max(0, (r.top + r.height / 2) / window.innerHeight)),
    }
  }
  confetti({ particleCount: 70, spread: 75, startVelocity: 30, scalar: 0.9, origin, zIndex: 9999 })
}

/** Pháo hoa LỚN (mừng hạ trùm / hoàn thành cả phần). Hai bên bắn liên tục ~900ms + 1 burst giữa. */
export function celebrateBig() {
  const end = Date.now() + 900
  const frame = () => {
    confetti({ particleCount: 6, angle: 60, spread: 70, startVelocity: 45, origin: { x: 0, y: 0.7 }, zIndex: 10000 })
    confetti({ particleCount: 6, angle: 120, spread: 70, startVelocity: 45, origin: { x: 1, y: 0.7 }, zIndex: 10000 })
    if (Date.now() < end) requestAnimationFrame(frame)
  }
  frame()
  confetti({ particleCount: 150, spread: 110, startVelocity: 45, scalar: 1.1, origin: { x: 0.5, y: 0.5 }, zIndex: 10000 })
}

/** Lời nhắn động viên khi sai — dùng chung để nhất quán giữa các loại câu hỏi. */
export const WRONG_ENCOURAGE = '😅 Chưa đúng rồi — hãy xem lại kiến thức phần trên rồi thử lại nhé!'
